import angular from 'angular';

(() => {
  class Tracking {
    constructor($state, $http, Endpoints, Orders, Auth) {
      'ngInject';

      Object.assign(this, {
        $state,
        $http,
        Endpoints,
        Orders,
        Auth
      });
    }
    /**
    * Initializes payload data
    * @name initializePayload
    * @memberof Tracking (factory)
    * @return initial payload
    */


    initializePayload(screen_id = null) {
      const payload = {};
      payload.platform = 'web';
      payload.application = 'pims';
      payload.user_uuid = 'pims';
      payload.session_uuid = 'pims';
      payload.date_pacific = new Date(new Date().toLocaleString("en-US", {
        timeZone: "America/Los_Angeles"
      })).toISOString().substring(0, 10);
      if (this.Orders.current && this.Orders.current.id) payload.order_id = this.Orders.current.id;
      if (this.Auth.profile && this.Auth.profile.id) payload.user_id = this.Auth.profile.id;
      payload.screen_id = screen_id || this.$state.current.pageTitle || this.$state.current.name;
      return payload;
    }

    trackEvent(event, attribute, screen_id = null) {
      this.trackAction(event, attribute, screen_id);
    }
    /**
    * Sends an user action to the mongo tracking DB
    * @name trackAction
    * @memberof Tracking (factory)
    * @return promise (which is returning from a POST)
    */


    trackAction(action, attribute, screen_id = null) {
      // console.log("CLICKED => TRACKING");
      const payload = this.initializePayload(screen_id);
      payload.actionLog = {};
      payload.actionLog.event = action;
      const actionDetails = [];

      if (attribute && Array.isArray(attribute) && attribute.length) {
        attribute.forEach((data, index) => {
          if (index === 0 && data) {
            payload.actionLog.screen = data; // console.log('screen: ' + data);
          }

          if (index === 1 && data) {
            payload.actionLog.label = data; // console.log('label: ' + data);
          }

          if (index > 1 && data) {
            actionDetails.push(data);
          }
        });
        payload.actionLog.details = actionDetails; // console.log('details: ' + actionDetails);
      } else if (attribute && attribute.dataArray && Array.isArray(attribute.dataArray) && attribute.dataArray.length) {
        attribute.dataArray.forEach((data, index) => {
          if (index === 0 && data) {
            payload.actionLog.screen = data; // console.log('screen: ' + data);
          }

          if (index === 1 && data) {
            payload.actionLog.label = data; // console.log('label: ' + data);
          }

          if (index > 1 && data) {
            actionDetails.push(data);
          }
        });
        payload.actionLog.details = actionDetails; // console.log('details: ' + actionDetails);
      } else if (attribute && attribute.actionLog) {
        payload.actionLog = attribute.actionLog;
        payload.actionLog.event = action;
      }

      console.log('actionLog: ', payload.actionLog);
      return this.$http.post(this.Endpoints.tracking.base, payload, {
        ignoreLoader: true
      });
    }
    /**
    * Sends an error to the mongo tracking DB
    * @name trackError
    * @memberof Tracking (factory)
    * @return promise (which is returning from a POST)
    */


    trackError(error, functionName, screen_id = null) {
      if (!error) error = {};
      const payload = this.initializePayload(screen_id);
      let errorLog = error;
      if (errorLog && errorLog.errApi && errorLog.errApi.config && errorLog.errApi.config.data) delete errorLog.errApi.config.data;
      if (errorLog && errorLog.config && errorLog.config.data) delete errorLog.config.data;
      payload.errorLog = errorLog; // Name of the function that generated the error

      payload.funcName = functionName;
      return this.$http.post(this.Endpoints.tracking.base, payload, {
        ignoreLoader: true
      });
    }

  }

  Tracking.$inject = ["$state", "$http", "Endpoints", "Orders", "Auth"];
  angular.module('pims').service('Tracking', Tracking);
})();